import { Elements } from '@stripe/react-stripe-js';
import { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import React from 'react';
import { useConfigQuery } from 'utils/api/useConfigQuery';

interface WrapperProps {
  children: React.ReactNode | null;
}

export default function ElementsWrapper({ children }: WrapperProps) {
  const { data } = useConfigQuery();
  const stripeConfig = data?.config.stripe.instance_id;
  const [stripe, setStripe] = React.useState<Promise<Stripe | null> | null>(null);

  React.useEffect(() => {
    if (stripeConfig) {
      setStripe(loadStripe(stripeConfig));
    }
  }, [stripeConfig]);

  return <Elements stripe={stripe}>{children}</Elements>;
}
